import styled from 'styled-components';
import { Segment as SegmentLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const mobileLimit = (breakpoints) => `${breakpoints.sm - 1}px`;

const Card = styled(SegmentLayoutComponent)`
  min-height: 450px;
  min-width: 650px;

  &.ui.segment {
    padding: 30px;
    @media (max-width: ${({ theme }) => mobileLimit(theme.breakpoints)}) {
      padding: 20px;
      display: flex;
      min-width: 100%;
      flex-direction: column;
    }
  }
`;

const Title = styled(TextLayoutComponent.Header)`
  margin-left: 25px;
  @media (max-width: ${({ theme }) => mobileLimit(theme.breakpoints)}) {
    margin: 0;
    text-align: center;
  }
`;

const ContainerDropDown = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 25px;
  @media (max-width: ${({ theme }) => mobileLimit(theme.breakpoints)}) {
    margin: 25px 0 0 0;
    justify-content: center;
  }
`;

const ContainerTimerSchedule = styled.div`
  margin-top: 25px;
`;

const Container = styled.div`
  margin: 0 25px;
  @media (max-width: ${({ theme }) => mobileLimit(theme.breakpoints)}) {
    margin: 0;
  }
`;

export {
  Card,
  Title,
  ContainerDropDown,
  ContainerTimerSchedule,
  Container,
};
